// extracted by mini-css-extract-plugin
export default {"phoneInput":"validated-phone-input_phoneInput__t8783"};